import { render, staticRenderFns } from "./companyImagesSlider.vue?vue&type=template&id=11a8af38&"
import script from "./companyImagesSlider.vue?vue&type=script&lang=js&"
export * from "./companyImagesSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports